// Types
import type { RouteRecordRaw } from 'vue-router';
import { prefixRouteNames } from '@/shared/utils/routes';

export default [
    {
        path: 'profile',
        name: 'profile',
        component: () => import('./components/modals/Profile/ProfileModal.vue'),
        beforeEnter: (to, from) => {
            if (from.name) {
                return true;
            }

            for (let i = to.matched.length - 2; i >= 0; i--) {
                const ancestor = to.matched[i]!;
                if (ancestor.name && !ancestor.meta?.modal) {
                    return {
                        name: String(ancestor.name),
                        params: to.params,
                        query: to.query,
                    };
                }
            }

            return {
                name: 'dashboard',
                params: to.params,
                query: to.query,
            };
        },
        meta: {
            modal: true,
        },
        children: prefixRouteNames('profile', [
            {
                path: 'reset-password',
                name: 'reset-password',
                component: () => import('./components/modals/ResetPassword/ResetPasswordModal.vue'),
                meta: {
                    returnRoute: 'profile',
                },
            },
            {
                path: 'two-factor-setup',
                name: 'two-factor-setup',
                component: () => import('./components/modals/TwoFactor/TwoFactorSetup.vue'),
                props: () => ({
                    authStep: true,
                }),
                meta: {
                    returnRoute: 'profile',
                },
            },
            {
                path: 'two-factor-disable',
                name: 'two-factor-disable',
                component: () => import('./components/modals/TwoFactor/TwoFactorDisable.vue'),
                meta: {
                    returnRoute: 'profile',
                },
            },
            {
                path: 'two-factor-regenerate-codes',
                name: 'two-factor-regenerate-codes',
                component: () => import('./components/modals/TwoFactor/TwoFactorRegenerateCodes.vue'),
                meta: {
                    returnRoute: 'profile',
                },
            }
        ]),
    },
    {
        path: 'notifications',
        name: 'notifications',
        component: () => import('./components/modals/Notifications/NotificationsSettingsModal.vue'),
        meta: {
            modal: true,
        },
    },
    {
        path: 'preferences',
        name: 'preferences',
        component: () => import('./components/modals/Preferences/PreferencesModal.vue'),
        meta: {
            modal: true,
        },
    },
    {
        path: 'logout',
        name: 'logout',
        component: () => import('./components/modals/Logout/LogoutModal.vue'),
        meta: {
            modal: true,
        },
    },
    {
        path: 'news',
        name: 'news',
        component: () => import('./components/modals/News/NewsModal.vue'),
        meta: {
            modal: true,
        },
        props: (route) => {
            return {
                link: route.query.link,
                showCheckbox: route.query.showCheckbox === 'true',
            };
        },
    },
    {
        path: 'exit-control',
        name: 'exit-control',
        component: () => import('./components/modals/ExitControl/ExitControlModal.vue'),
        meta: {
            modal: true,
        },
    },
    {
        path: 'support',
        name: 'support',
        component: () => import('./components/modals/Support/SupportModal.vue'),
        meta: {
            modal: true,
        },
    },
] satisfies RouteRecordRaw[];
